/**
 * @function ParticipantListEmpty
 * @description Component for displaying a message when there are no participants.
 * @returns {JSX.Element | null} - The ParticipantListEmpty component.
 */
import ParticipantsIcon from '../../assets/menu/participants.svg'

/**
 * @function ParticipantListEmpty
 * @description Component for displaying a message when there are no participants.
 * @returns {JSX.Element | null} - The ParticipantListEmpty component.
 */
export function ParticipantListEmpty() {
    return (
        <div className="flex flex-col grow justify-center mt-32 px-8 py-8">
            <div className="flex self-center flex-col items-center">
                <div className="flex justify-center items-center w-16 h-16 rounded-full bg-indigo-50 mb-4">
                    <ParticipantsIcon className="w-6 h-6 stroke-indigo-500 stroke-2" />
                </div>
                <h2 className="mb-3 text-gray-900 text-xl font-semibold">
                    No participants to display
                </h2>
                <div className="text-base text-gray-600 text-center">
                    <p>No matching participants or insufficient permissions to view.</p>
                </div>
            </div>
        </div>
    )
}
